import axios from 'axios';
import {backendHost} from '../../config';

export const putInvite = (params) => {
    return axios.put(`${backendHost}/api/partners/admin/invite`, params);
};